import { createSelector } from '@reduxjs/toolkit';
import { ClientAccountSelectModel } from '../../common/store/types';
import { selectClientState } from '../../store/selectors';
import { CashAccount } from './types';

export const selectCashAccountsState = createSelector(selectClientState, (clientState) => clientState.cashAccounts);
export const selectParameters = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState.parameters);
export const selectCashStatementResults = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState?.cashStatements);
export const selectShowAudValues = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState.showAudValues);
export const selectLastDataRefresh = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState?.lastDataRefresh ?? null);

export const selectCashAccounts = createSelector(selectCashAccountsState, (cashAccountsState) => cashAccountsState.cashAccounts);

export const selectCashAccountOptions = createSelector(selectCashAccounts, (cashAccounts: CashAccount[] | null) => {
  const accountsSelectList: ClientAccountSelectModel[] = (cashAccounts ?? []).map((i) => {
    return {
      accountId: i.accountId,
      accountName: i.accountName,
      accountNumber: i.accountNumber,
      accountIdList: [i.accountId],
      securities: i.securities ?? [],
    };
  });

  return accountsSelectList.sort((a, b) => a.accountName.localeCompare(b.accountName));
});

export const formatAccountLabel = (account: ClientAccountSelectModel | null): string =>
  !account ? '' : [account.accountNumber, account.accountName].filter((part) => !!part).join(' - ');

export const selectSelectedAccount = createSelector(
  selectCashAccountOptions,
  selectParameters,
  (accounts, parameters) => accounts.find((account) => account.accountId === parameters.selectedAccountId) ?? null
);

export const selectSelectedAccountLabel = createSelector(selectSelectedAccount, formatAccountLabel);

export const selectSelectedAccountSecurities = createSelector(selectSelectedAccount, (account) => account?.securities ?? []);

export const selectCanShowAudValues = createSelector(selectCashStatementResults, (cashStatements) =>
  (cashStatements?.results ?? []).some((line) => line.balanceAud != null && line.balance != null && line.balanceAud !== line.balance)
);
